<template lang="pug">
  footer.main-footer
    .pull-right.small.hidden-xs
      | Version
      | &nbsp;{{$store.getState('service_version')}}
    .text-center.small
      | Copyright (c)&nbsp;
      a(:href="$store.getState('service_owner_url')") {{$store.getState('service_owner')}}
      | All rights reserved.

</template>

<script>
export default {
  name: 'TheFooter'
}
</script>

<style lang="scss" scoped>
  .main-footer {
    // 画面下部のボタンを押しやすくするため
    // 「ページ先頭に戻る」が重ならないようにするため
    // 高さに余裕を持たせる
    min-height: 80px;
    padding: 5px 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/organisms/TheFooter.vue